<template>
    <div>
        111
        <Signature v-if="QianMingBlon" @Suc="QianMingSuc" @back="Back"></Signature>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                QianMingBlon:true,
            };
        },
        mounted() {
            
        },
        methods: {
           QianMingSuc(data){
                this.$post("/apis/final/signature", {
                   code: this.$route.params.id,
                   base64: data,
               }).then(res => {
                   if (res) {
                       this.$toast.text(res.msg);
                       this.QianMingBlon = false;
                       setTimeout(()=>{
                           window.close();
                       },1000)
                   }
               })
           },
           Back(){
               this.$toast.text("当前无返回页面，请进行签名确认后退出");
           }
        }
    }
</script>

<style scoped>
    .SearchHead{
        margin: 10px;
    }
    .NoData{
        text-align: center;
        padding: 10px 0;
        color: #999;
        font-size: 14px;
    }
</style>